import React, { useEffect, useState } from "react";
import LacunaWebPKI from 'web-pki';
import { InputSelect } from "../../components/Inputs/InputSelect";
import { Button, Grid, Typography } from "@mui/material";
import { useForm } from "../../hooks/useForm";
import { useLang } from "../../language";
import ModalPlugin from "./ModalPlugin";

export const Firma = ({formDatosFirma, handleInputDatosFirma, pki, setPki, certificates, setCertificates, readyPKI, setreadyPKI}:any) => {

    const Lang = useLang()

    /*const [formDatosFirma, handleInputDatosFirma, handleFormDatosFirma, handleResetFormDatosFirma] = useForm({
        certificado: ''
    })*/

    // ---------- Modal Info Plugin

    const [dataModal_InfoPlugin, setDataModal_InfoPlugin] = useState({
        value: false,
        payload: null
    });

    const handleCloseModal_InfoPlugin = () => setDataModal_InfoPlugin({
        value: false,
        payload: null
    })

    const handleShowModal_InfoPlugin = (payload: any) => setDataModal_InfoPlugin({
        value: true,
        payload
    });

    // Web pki

    const [showBtnModalPlugin, setshowBtnModalPlugin] = useState(false)

    function onWebPkiNotInstalled(status: any, message: string) {
        console.log('InstalÂ·laciÃ³ incorrecta: ' + message);
        setreadyPKI(true)
        setshowBtnModalPlugin(true)
        // handleShowModalPlugin()
    }

    function onWebPkiReady() {
        console.log('Component ready.');
        loadCertificates();
        setreadyPKI(true)
    }

    function loadCertificates() {
        console.log('Llistant certificats ...');

        pki.listCertificates({
            filter: pki.isWithinValidity
        }).success(function (certificates: any) {
            console.log('Certificats llistats.', certificates);
            setCertificates(certificates)
        });
    }

    function onWebPkiError(message: any, error: any, origin: any) {
        console.log('Web PKI error originat a ' + origin + ': ' + error);
        setreadyPKI(true)
    }

    useEffect(() => {

        let pkiT = new LacunaWebPKI({
            "format": 2,
            "allowedDomains": [
                "*.apabcn.cat",
                "*.enginyersbcn.cat",
                "*.dapcons.com",
                "*.libroedificiodigital.es",
                "*.enginyersgp.cat",
                "*.cetill.cat",
                "*.arescoop.es",
                "*.cateb.cat",
                "*.enginyerslleida.cat",
                "*.testaluminos.cat"
            ],
            "homologDomains": [
                "ip4:10.0.0.0/8",
                "ip4:127.0.0.0/8",
                "ip4:172.16.0.0/12",
                "ip4:192.168.0.0/16"
            ],
            "productLevel": "Pro",
            "expiration": null,
            "signature": "r/uqryvMqGfeEltn6IdyJyeC6VFJ6ZLk0hoyefIdpGeQM4KC2fqfJ6fhXK821uGYwzClxIj0gQvw/S/REiNAvMJ4GIQe2VHZSofjTgRXE9Yx0qUSvl9+G/6UT68tlPgAQ8FdfPoP9u+UTwLVoM9Zu0UsAEZCK/KYEwKHMQ+Scle/cyeiik3NfCA98rgX0jOGyiz3LV6b2Q5A255VdwGVSyP/7pX4v8vj+cQNWtHfe6ejsrv22GD1B4a+n56rQvLSNCbFFQczxe7/++oia2UcCpaa+aGjoLDrz9u2GCoBBn9tcG4qBzMS1Z1A5xW2177/oAWnWnzOIDrLdRzxy9+5Bg=="

        });

        setPki(pkiT)

    }, [])

    useEffect(() => {

        if (pki) {

            pki.init({
                ready: onWebPkiReady,
                notInstalled: onWebPkiNotInstalled,
                defaultError: onWebPkiError
            });
        }

    }, [pki])

    // Instalar plugin

    return (
        <Grid item xs={12}>

            <Grid container spacing={3} justifyContent="center" >
                <Grid item xs={12} className="pb-0 pt-0">
                    <Typography variant="subtitle1" className='mb-2 fw-500 color-primary' sx={{ mt: 2 }}>
                        Seleccioneu un certificat per signar:
                    </Typography>
                </Grid>

                <Grid item xs={12} lg={6} xl={6} className="pt-0">

                    <InputSelect
                        label={Lang('CERTIFICADO') + ' *'}
                        name='certificado'
                        onChange={handleInputDatosFirma}
                        value={formDatosFirma.certificado}
                        values={certificates?.map((item: any) => {
                            return {
                                id: item.thumbprint,
                                name: `${item.subjectName} ' (issued by '${item.issuerName}')`
                            }
                        }) || []}
                    // readOnly={!isEmptyDataCEE}
                    // localValidation={validCEE.certificado}
                    />

                </Grid>

                <Grid item xs={12} lg={6} xl={6} className="pt-2">
                    {
                        showBtnModalPlugin &&
                        <Button
                            color="primary"
                            variant="outlined"
                            className='ml-0'
                            onClick={handleShowModal_InfoPlugin}
                        >
                            Instalar Plugin de Firma
                        </Button>
                    }
                </Grid>
            </Grid>

            <ModalPlugin
                dataModal_InfoPlugin={dataModal_InfoPlugin}
                handleCloseModal_InfoPlugin={handleCloseModal_InfoPlugin}
                pki={pki}
            />
        </Grid>
    )
};
